import React from "react";
import ImageWithTag from "./ImageWithTag";

function Block1() {
  return (
    <>
      <div className="p-3">
        {/* Image */}
        <ImageWithTag />
        {/* Text */}
        <div className="text-xl py-2.5">
          Top Fashion Trends to Look for in Every Important Collection
        </div>
        {/* Author + Date */}
        <div className="flex flex-row">
          {/* Author */}
          <div className="text-xs-s font-bold">God Of Thunder</div>
          {/* Date */}
          <div className="text-xs-s font-semibold text-gray-400 ml-4">
            August 7, 2021
          </div>
        </div>

        {/* Description */}
        <div className="text-sm py-2">
          Occaecat qui excepteur id consectetur nostrud commodo ad commodo sit
          ipsum. Tempor magna ut mollit cupidatat occaecat laboris incididunt
        </div>
      </div>
    </>
  );
}

export default Block1;
